import { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";

import imgFechar from "../../../assets/img/sistema/close.svg";
import { Container } from "./styles";
import NovoModal from "../../../components/NovoModal";
import { api } from "../../../services/api";
import Loading from "../../Loading";
import Button from "../../button";
import { toast } from "react-toastify";

// Configura o worker do PDF.js
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export function Regulamento(props) {
    const { contas = [] } = props;
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [numPages, setNumPages] = useState(null);
    const idGP = contas[0]?.[0]?.acao_id || null;
    const idGC = contas[0]?.acao_id || null;
    const id = idGP || idGC;

    const modalTermosGp = contas.some((item) => {
        if (item[0]) {
            if (item[0]?.acao?.exibir_modal_termos === true) return true;
        }
        return false;
    });

    const modalTermosGC = contas?.some((item) => {
        if (item?.acao?.exibir_modal_termos === true) return true;
        return false;
    });

    const modalTermos = modalTermosGp || modalTermosGC;

    // Função para confirmar o aceite do regulamento
    async function handleRegulamento() {
        try {
            if (!id) {
                toast.error("Ação não encontrada");
                return;
            }
            const response = await api.post(
                `/termo/acceptance-of-terms/${id}`,
                {
                    accepted: true,
                }
            );
            toast.success(response.data.message);
            setOpenModal(false);
        } catch (error) {
            console.log(error);
            toast.error("Erro ao aceitar o regulamento");
        }
    }

    // Efeito para buscar o PDF quando o modal deve ser exibido
    useEffect(() => {
        async function getRegulamento() {
            setOpenModal(true);
            try {
                setLoading(true);
                // Solicita o PDF e espera ele vir como blob
                const response = await api.get(`/termo/${id}`, {
                    responseType: "blob",
                });
                if (response.status === 200) {
                    const pdfBlob = response.data;
                    // Cria uma URL que será utilizada pelo react-pdf
                    setFile(URL.createObjectURL(pdfBlob));
                } else {
                    toast.error("Erro ao buscar o regulamento");
                }
                setLoading(false);
            } catch (error) {
                setLoading(false);
                console.log(error);
                toast.error("Erro ao buscar o regulamento");
            }
        }

        if (modalTermos) {
            getRegulamento();
        }
    }, [id, modalTermos]);

    return (
        <NovoModal open={openModal} handleClose={() => {}}>
            <Container>
                {/* <button
                    className="btn-close"
                    onClick={() => setOpenModal(!openModal)}
                >
                    <img src={imgFechar} alt="Fechar modal" />
                </button> */}
                {loading && <Loading />}
                {!loading && file && (
                    <>
                        <div
                            className="pdf-viewer"
                            style={{ overflow: "auto", maxHeight: "80vh" }}
                        >
                            <Document
                                file={file}
                                onLoadSuccess={({ numPages }) =>
                                    setNumPages(numPages)
                                }
                            >
                                {Array.from(
                                    new Array(numPages),
                                    (el, index) => (
                                        <Page
                                            key={`page_${index + 1}`}
                                            pageNumber={index + 1}
                                        />
                                    )
                                )}
                            </Document>
                        </div>
                        <Button
                            title="Confirmo que li o Regulamento"
                            onClick={handleRegulamento}
                        />
                    </>
                )}
            </Container>
        </NovoModal>
    );
}
